import React, { Fragment } from "react";
import { Table } from "antd";
import { editIcon, View } from "../../Elite/imageAssets";

const VendorDataTable = ({
  vendorTableData = [],
  total = 0,
  pageSize,
  currentPage = 1,
  visitorLoading,
  onTableChange,
  handleEditData,
  sortField,
  sortOrder,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const d = new Date(dateString);

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = d.getFullYear();

    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    const sec = String(d.getSeconds()).padStart(2, "0");

    return `${dd}/${mm}/${yy} ${hh}:${min}:${sec}`;
  };

  const columns = [
    {
      title: "Vendor ID",
      dataIndex: "vendorId",
      key: "vendorId",
      width: 120,
      sorter: true,
      sortOrder: sortField === "vendorId" ? sortOrder : null,
      render: (t) => <label>{t}</label>,
    },
    {
      title: "Vendor Company Name",
      dataIndex: "vendorName",
      key: "vendorName",
      width: 200,
      sorter: true,
      sortOrder: sortField === "vendorName" ? sortOrder : null,
      render: (t) => <label>{t}</label>,
    },
    {
      title: "Vendor Type",
      dataIndex: "vendorType",
      key: "vendorType",
      width: 140,
      sorter: true,
      sortOrder: sortField === "vendorType" ? sortOrder : null,
      render: (t) => <label>{t || "N/A"}</label>,
    },
    {
      title: "Status",
      dataIndex: "approvalStatus",
      key: "approvalStatus",
      width: 230,
      sorter: true,
      sortOrder: sortField === "approvalStatus" ? sortOrder : null,
      render: (status) => {
        let color = "#55595C";

        switch ((status || "").toLowerCase()) {
          case "approved":
            color = "#08A34B";
            break;
          case "rejected":
            color = "#E80808";
            break;
          case "requested":
            color = "#3A8DFD";
            break;
          case "pending with internal user":
          case "pending with finance team":
          case "pending with finance hod":
            color = "#FBA81C";
            break;
          default:
            color = "#595959";
        }

        return (
          <label style={{ color, fontWeight: 500 }}>{status || "N/A"}</label>
        );
      },
    },
    {
      title: "SAP Code",
      dataIndex: "saP_Code",
      key: "saP_Code",
      width: 120,
      sorter: true,
      sortOrder: sortField === "saP_Code" ? sortOrder : null,
      render: (t) => <label>{t || "N/A"}</label>,
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      width: 180,
      sorter: true,
      sortOrder: sortField === "owner" ? sortOrder : null,
      render: (t) => <label>{t}</label>,
    },

    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      sorter: true,
      sortOrder: sortField === "createdAt" ? sortOrder : null,
      render: (t) => <label>{formatDate(t)}</label>,
    },
    {
      title: "Modified Date",
      dataIndex: "modifiedAt",
      key: "modifiedAt",
      width: 150,
      sorter: true,
      sortOrder: sortField === "modifiedAt" ? sortOrder : null,
      render: (t) => <label>{formatDate(t)}</label>,
    },
    {
      title: "Modified By",
      dataIndex: "modifiedBy",
      key: "modifiedBy",
      width: 130,
      sorter: true,
      sortOrder: sortField === "modifiedBy" ? sortOrder : null,
      render: (t) => <label>{t || "N/A"}</label>,
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (_text, record) => (
        <div className="table_action_img">
          {record.canEdit && (
            <div>
              <img
                src={editIcon}
                alt="edit"
                onClick={
                  () => handleEditData(record, "edit") // Pass "edit" explicitly
                }
              />
            </div>
          )}
          <div className="tbl_info_details">
            <img
              src={View}
              className="viewImg ml-8"
              style={{ cursor: "pointer", width: 17 }}
              alt="view"
              onClick={
                () => handleEditData(record, "view") // Always force view mode
              }
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Table
        bordered
        scroll={{ x: 1000 }}
        className="gatePassTbl payment_table vendor-table"
        columns={columns}
        dataSource={Array.isArray(vendorTableData) ? vendorTableData : []}
        rowKey="vendorId"
        rowClassName={(_, index) => (index % 2 === 0 ? "even-row" : "odd-row")}
        loading={visitorLoading}
        onChange={onTableChange}
        pagination={{
          total,
          current: currentPage,
          pageSize,
          responsive: true,
          showSizeChanger: false,
        }}
      />
    </Fragment>
  );
};

export default VendorDataTable;
